import React from 'react';
import { Money, type MoneyProps, type MoneyType } from '../Money';

/**
 * Сумма в рублях (как `Money`: формат `formatCurrency`, напр. «300 000 ₽»).
 * По умолчанию — нейтральный цвет; для доход/расход задать `type`.
 */
export type MoneyCellProps = Omit<MoneyProps, 'type'> & {
  type?: MoneyType;
};

export const MoneyCell: React.FC<MoneyCellProps> = ({ type = 'neutral', ...rest }) => (
  <Money type={type} {...rest} />
);

export default MoneyCell;
